import React from 'react';
import '../style/TypingAnimation.scss';

const TypingAnimation = () => {
  return (
    <div className="typing-indicator d-flex align-items-center">
      <div className="typing-dots p-4 rounded-2">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default TypingAnimation;
